import ProdacLogo from '../../../assets/images/logo-prodac.png';
import ProdiminLogo from '../../../assets/images/logo-prodimin.png';
import { useAuth } from '../../../hooks/useAuth.hook';

const NextGlobalLoader = () => {
  const { user } = useAuth();
  const companyName = user?.sociedad;

  return (
    <div className="layer-global-loader next-global-loader items-center">
      {companyName === 'PRODAC' ? (
        <img alt="logo loader" src={ProdacLogo} className="my-auto" />
      ) : (
        <img alt="logo loader" src={ProdiminLogo} className="my-auto" />
      )}
    </div>
  );
};

export default NextGlobalLoader;
